module.exports = __webpack_public_path__ + "img/67.b8a324ee.jpg";